import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { Calculator, CalendarAlt, ChartLine, CircleInfo, Coins, FileLines, PaperPlane, Question, CircleDotted, ScaleBalanced, CircleCheck, ThumbsUp, File4Fill } from '../../../../components/icons/Icons'


const TdsCalculation = () => {
  return (
    <div>
      <Row className='mb-2'>
        <Col sm="6">
          <div className='emp-tds-card min-height-450-px mb-3'>
            <h3 className='color-white font-weight-200 mb-3 d-flex align-items-center gap-2'> <Coins class_name={"text-purple"} /> Annual Income</h3>

            <div className='d-flex align-items-center justify-content-between gap-2 mb-2'>
              <span className='color-gray font-14 font-weight-200'>Gross Salary (CTC)</span> <span className='color-white font-16 font-weight-200'>₹15,00,000</span>
            </div>

            <div className='d-flex align-items-center justify-content-between gap-2 mb-2'>
              <span className='color-gray font-14 font-weight-200'>HRA Exemption</span> <span className='text-green font-14 font-weight-200'>-₹1,80,000</span>
            </div>

            <div className='d-flex align-items-center justify-content-between gap-2 mb-2'>
              <span className='color-gray font-14 font-weight-200'>LTA Exemption</span> <span className='text-green font-14 font-weight-200'>-₹1,40,000</span>
            </div>

            <div className='d-flex align-items-center justify-content-between gap-2 mb-2'>
              <span className='color-gray font-14 font-weight-200'>Other u/s 10</span> <span className='text-green font-14 font-weight-200'>-₹20,000</span>
            </div>

            <hr className='color-gray' />

            <div className='d-flex align-items-center justify-content-between gap-2 mb-2'>
              <span className='color-gray font-14 font-weight-200'>Income after Exemptions</span> <span className='color-white font-16 font-weight-200'>₹12,50,000</span>
            </div>
          </div>
        </Col>
        <Col sm="6">
          <div className='emp-tds-card min-height-450-px mb-4'>
            <div className='d-flex align-items-center justify-content-between gap-2 mb-3'>
              <h3 className='color-white font-weight-200 d-flex align-items-center gap-2'><FileLines class_name={"text-purple"} /> Deductions</h3>
              <span className='color-gray font-12 font-weight-200 d-flex align-items-center gap-2'>Declared vs Allowed <CircleInfo class_name={"color-gray"} /> </span>
            </div>

            <div className='d-flex align-items-center justify-content-between gap-2 mb-2'>
              <h3 className='color-white font-14 font-weight-200 d-flex align-items-center gap-2'>80C <span className='color-gray font-12'>(cap 1.5L)</span></h3>
              <span className='color-gray font-12 font-weight-200 d-flex flex-column align-items-end gap-1'>
                <span className='color-gray font-14 font-weight-200'>₹1,80,000 → ₹1,50,000</span>
                <span className='yellow-text font-12 font-weight-200'>Capped</span>
              </span>
            </div>

            <hr className='color-gray' style={{ border: "3px solid gray", borderRadius: "8px" }} />

            <div className='d-flex align-items-center justify-content-between gap-2 mb-2'>
              <h3 className='color-white font-14 font-weight-200 d-flex align-items-center gap-2'>80D
                <span className='color-gray font-12'>(medical)</span>
              </h3>
              <span className='color-gray font-12 font-weight-200 d-flex flex-column align-items-end gap-1'>
                <span className='color-gray font-14 font-weight-200'>₹55,000 → ₹50,000</span>
                <span className='yellow-text font-12 font-weight-200'>Parents limit</span>
              </span>
            </div>

            <hr className='color-gray' style={{ border: "3px solid gray", borderRadius: "8px" }} />

            <div className='d-flex align-items-center justify-content-between gap-2 mb-2'>
              <h3 className='color-white font-14 font-weight-200 d-flex align-items-center gap-2'>80E
                <span className='color-gray font-12'>education</span>
              </h3>
              <span className='color-gray font-12 font-weight-200 d-flex flex-column align-items-end gap-1'>
                <span className='color-gray font-14 font-weight-200'>₹30,000 → ₹30,000</span>
                <span className='text-green font-12 font-weight-200'>Full allowed</span>
              </span>
            </div>

            <hr className='color-gray' style={{ border: "3px solid gray", borderRadius: "8px" }} />

            <div className='d-flex align-items-center justify-content-between gap-2 mb-2'>
              <h3 className='color-white font-14 font-weight-200 d-flex align-items-center gap-2'>80G
                <span className='color-gray font-12'>(donations)</span>
              </h3>
              <span className='color-gray font-12 font-weight-200 d-flex flex-column align-items-end gap-1'>
                <span className='color-gray font-14 font-weight-200'>₹20,000 → ₹10,000</span>
                <span className='yellow-text font-12 font-weight-200'>50% eligible</span>
              </span>
            </div>

            <hr className='color-gray' style={{ border: "3px solid gray", borderRadius: "8px" }} />
            <hr className='color-gray' />

            <div className='d-flex align-items-center justify-content-between gap-2 mb-2'>
              <h3 className='color-white font-14 font-weight-200 d-flex align-items-center gap-2'>Total Deductions (Allowed)</h3>
              <span className='badge-purple'>
                ₹2,40,000
              </span>
            </div>



          </div>
        </Col>

        <Col sm="4">
          <div className='emp-tds-card min-height-450-px'>
            <div className='d-flex align-items-center justify-content-between gap-2 mb-3'>
              <h3 className='color-white font-weight-200 d-flex align-items-center gap-2'>
                <Calculator class_name={"text-purple"} /> Taxable Income Formula
              </h3>
            </div>

            <div className='d-flex align-items-center justify-content-between gap-2 mb-3'>
              <span className='color-gray font-weight-200'>
                Income after Exemptions
              </span>

              <span className='color-white font-weight-200'>
                ₹12,50,000
              </span>
            </div>

            <center><span className='color-gray font-20'>-</span></center>

            <div className='d-flex align-items-center justify-content-between gap-2 mb-3'>
              <span className='color-gray font-weight-200'>
                Total Deductions (Allowed)
              </span>

              <span className='text-green font-weight-200'>
                ₹24,50,000
              </span>
            </div>

            <hr className='text-purple' style={{ border: "1px solid", borderRadius: "8px" }} />
            <center><span className='color-gray font-20'>=</span></center>

            <div className='d-flex align-items-center justify-content-between gap-2 mb-3'>
              <h3 className='color-white font-weight-200'>
                Taxable Income
              </h3>

              <span className='text-purple font-weight-200 font-20'>
                ₹10,10,000
              </span>
            </div>

          </div>
        </Col>

        <Col sm="8">
          <div className='emp-tds-card min-height-450-px'>
            <div className='d-flex align-items-center justify-content-between gap-2 mb-2'>
              <h3 className='color-white font-weight-200 d-flex align-items-center gap-2'> <ChartLine class_name={"text-purple"} /> Slab-wise Tax Computation</h3>
              <span className='badge-purple font-16 font-weight-200'>New Regime</span>
            </div>

            <table className='tds-table'>
              <thead>
                <tr>
                  <th>Slab Range</th>
                  <th>Rate</th>
                  <th>Portion</th>
                  <th>Tax</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>₹0 - ₹3L</td>
                  <td>0%</td>
                  <td>₹300,000</td>
                  <td>₹0</td>
                </tr>

                <tr>
                  <td>₹3L - ₹6L</td>
                  <td>5%</td>
                  <td>₹300,000</td>
                  <td>₹15,000</td>
                </tr>

                <tr>
                  <td>₹6L - ₹9L</td>
                  <td>10%</td>
                  <td>₹300,000</td>
                  <td>₹15,000</td>
                </tr>

                <tr>
                  <td>₹9L - ₹12L</td>
                  <td>15%</td>
                  <td>₹300,000</td>
                  <td>₹15,000</td>
                </tr>

                <tr>
                  <td>₹12L</td>
                  <td>20%</td>
                  <td>₹300,000</td>
                  <td>₹15,000</td>
                </tr>
              </tbody>
            </table>

            <div className='d-flex align-items-center justify-content-between gap-2 mt-2 mb-4'>
              <h3 className='color-white font-weight-200 d-flex align-items-center gap-2'>
                Subtotal (Income Tax)
              </h3>
              <span className='text-purple font-16 font-weight-200'>₹62,000</span>
            </div>


            <div className='d-flex align-items-center justify-content-between gap-2 mt-2 mb-2'>
              <h3 className='color-white font-14 font-weight-200 d-flex align-items-center gap-2'>
                + Health & Education Cess  <span className='color-gray font-weight-200 font-12'>(4%)</span>
              </h3>
              <span className='yellow-text font-16 font-weight-200'>₹2,480</span>
            </div>

            <div className='d-flex align-items-center justify-content-between gap-2 mt-2 mb-2'>
              <h3 className='color-white font-14 font-weight-200 d-flex align-items-center gap-2'>
                - Rebate u/s 87A  <span className='color-gray font-weight-200 font-12'>(4%)</span>
              </h3>
              <span className='text-green font-16 font-weight-200'>₹0</span>
            </div>

            <div style={{ borderBottom: "1px solid #8B5CF6", borderRadius: "8px" }} />

            <div className='d-flex align-items-center justify-content-between gap-2 mt-2 mb-2'>
              <h3 className='color-white font-weight-200 d-flex align-items-center gap-2'>
                Total Yearly TDS
              </h3>
              <span className='badge-purple font-16 font-weight-200'>₹64,480</span>
            </div>
          </div>
        </Col>
      </Row>

      <Row className='mb-2 p-3'>
        <div className='emp-tds-card'>

          <div className='d-flex align-items-center justify-content-between gap-2 mb-4'>
            <h3 className='color-gray font-weight-200 d-flex align-items-center gap-2'> <CalendarAlt class_name={"text-purple"} /> Monthly TDS Planner</h3>
            <div className='d-flex align-items-center gap-4 mb-4'>
              <span className='color-gray font-16 font-weight-200'>Months in FY:
                <span className='color-white font-16 font-weight-200'> 12</span>
              </span>

              <span className='color-gray font-16 font-weight-200'>Months elapsed:
                <span className='yellow-text font-16 font-weight-200'> 7</span>
              </span>

              <span className='color-gray font-16 font-weight-200'>Remaining:
                <span className='text-purple font-16 font-weight-200'> 5</span>
              </span>
            </div>

          </div>

          <Row className='mb-3'>
            <Col sm="4" className='mb-3'>
              <div className='emp-tds-card d-flex flex-column align-items-center gap-2'>
                <span className='color-gray font-16 font-weight-200'>TDS Deducted YTD</span>
                <h3 className='text-red font-weight-200'>₹1,27,598</h3>
              </div>
            </Col>

            <Col sm="4" className='mb-3'>
              <div className='emp-tds-card d-flex flex-column align-items-center gap-2'>
                <span className='color-gray font-16 font-weight-200'>Balance to Deduct</span>
                <h3 className='text-purple font-weight-200'>₹1,27,598</h3>
              </div>
            </Col>

            <Col sm="4" className='mb-3'>
              <div className='emp-tds-card d-flex flex-column align-items-center gap-2'>
                <span className='color-gray font-16 font-weight-200'>Avg per Remaining Month</span>
                <h3 className='text-green font-weight-200'>₹1,27,598</h3>
              </div>
            </Col>
          </Row>

          <table className='tds-table'>
            <thead>
              <tr>
                <th style={{ width: "300px" }}>Month</th>
                <th className='width-150-px'>Planned TDS</th>
                <th >Lock</th>
                <th >Notes</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Nov 2024</td>
                <td><span className='badge-lightgray border-radius-8px margin-top-m-13-px '>18250</span></td>
                <td><input type="checkbox" /></td>
                <td>-</td>
              </tr>

              <tr>
                <td>Dec 2024</td>
                <td className=''><span className='badge-lightgray border-radius-8px margin-top-m-13-px '>25000</span></td>
                <td><input type="checkbox" /></td>
                <td><span className='badge-lightgray border-radius-8px margin-top-m-13-px '>Arrears adj</span></td>
              </tr>

              <tr>
                <td>Jan 2025</td>
                <td><span className='badge-lightgray border-radius-8px margin-top-m-13-px '>18250</span></td>
                <td><input type="checkbox" /></td>
                <td>-</td>
              </tr>

              <tr>
                <td>Feb 2025</td>
                <td><span className='badge-lightgray border-radius-8px margin-top-m-13-px '>18250</span></td>
                <td><input type="checkbox" /></td>
                <td>-</td>
              </tr>

              <tr>
                <td>March 2025</td>
                <td><span className='badge-lightgray border-radius-8px margin-top-m-13-px '>18250</span></td>
                <td><input type="checkbox" /></td>
                <td><span className='badge-lightgray border-radius-8px margin-top-m-13-px '>Final true-up</span></td>
              </tr>
            </tbody>
          </table>
          <div className='d-flex align-items-center justify-content-between gap-2 mt-3'>
            <div className='d-flex align-items-center gap-3'>
              <button className='universal-btn border-radius-8px d-flex align-items-center gap-3'> <div className='two-icons' style={{ marginLeft: "8px" }}>
                <CircleDotted class_name={"icon"} /> <Question class_name={"icon-1"} />
              </div> Auto-Spread Balance</button>
              <button className='universal-btn-green border-radius-8px'> <Coins /> Apply Rounding</button>
              <button className='universal-btn-orange border-radius-8px'> <PaperPlane /> Push to Payroll</button>
            </div>

            <div className='d-flex align-items-center gap-3 color-white'>
              <input type='checkbox' />
              <span>Include arrears/bonus simulation</span>
            </div>

          </div>
        </div>
      </Row>

      <div className='setting-border height-auto p-4'>
        <h3 className='color-white d-flex align-items-center gap-2 font-weight-200 mb-3'> <ScaleBalanced class_name={"text-purple"} /> Tax Regime Comparison </h3>

        <Row>
          <Col sm="6">
            <div className='emp-tds-card'>
              <div className='d-flex justify-content-between align-items-center gap-2 mb-2'>
                <span className='color-white font-14 font-weight-200'>Old Regime</span>
                <span className='badge-gray font-weight-200'>Traditional</span>
              </div>

              <div className='d-flex justify-content-between align-items-center gap-2 mb-2'>
                <span className='color-gray font-14 font-weight-200'>Taxable Income</span>
                <span className='color-white font-weight-200'>₹10,10,000</span>
              </div>

              <div className='d-flex justify-content-between align-items-center gap-2 mb-2'>
                <span className='color-gray font-14 font-weight-200'>Slab Tax</span>
                <span className='color-white font-weight-200'>₹2,32,500</span>
              </div>

              <div className='d-flex justify-content-between align-items-center gap-2 mb-2'>
                <span className='color-gray font-14 font-weight-200'>Cess (4%)</span>
                <span className='color-white font-weight-200'>₹9,300</span>
              </div>

              <hr className='color-gray' />

              <div className='d-flex justify-content-between align-items-center gap-2 mb-2'>
                <span className='color-white font-14 font-weight-200'>Total TDS</span>
                <span className='color-white font-weight-200'>₹2,41,800</span>
              </div>

            </div>
          </Col>

          <Col sm="6">
            <div className='emp-tds-card'>
              <div className='d-flex justify-content-between align-items-center gap-2 mb-2'>
                <span className='color-white font-14 font-weight-200'>New Regime</span>
                <span className='badge-purple font-weight-200'>Current</span>
              </div>

              <div className='d-flex justify-content-between align-items-center gap-2 mb-2'>
                <span className='color-gray font-14 font-weight-200'>Taxable Income</span>
                <span className='color-white font-weight-200'>₹10,10,000</span>
              </div>

              <div className='d-flex justify-content-between align-items-center gap-2 mb-2'>
                <span className='color-gray font-14 font-weight-200'>Slab Tax</span>
                <span className='color-white font-weight-200'>₹2,32,500</span>
              </div>

              <div className='d-flex justify-content-between align-items-center gap-2 mb-2'>
                <span className='color-gray font-14 font-weight-200'>Cess (4%)</span>
                <span className='color-white font-weight-200'>₹9,300</span>
              </div>

              <hr className='color-gray' />

              <div className='d-flex justify-content-between align-items-center gap-2 mb-2'>
                <span className='color-white font-14 font-weight-200'>Total TDS</span>
                <span className='color-white font-weight-200'>₹2,41,800</span>
              </div>

            </div>
          </Col>
        </Row>

        <div className='d-flex flex-column align-items-center gap-2 mt-4 mb-2'>
          <button className='badge-green'> <CircleCheck />  New regime saves ₹22,776 annually</button>
          <button className='universal-btn border-radius-8px d-flex align-items-center gap-2'> <ThumbsUp /> Recommend Switch</button>
        </div>
      </div>

      <div class="setting-border height-auto calculation-card mt-4 ">
          <h3 className='color-white'><File4Fill class_name={"text-purple"} /> Calculation Notes & Assumptions</h3>

          <div class="calculation-grid">
            <ul>
              <li>Allowed deductions reflect validated proofs; pending proofs excluded from calculation.</li>
              <li>Health & Education Cess @ 4% applied on income tax amount.</li>
              <li>Surcharge applied as per income thresholds when applicable (&gt;₹50L: 10%, &gt;₹1Cr: 15%).</li>
            </ul>

            <ul>
              <li>Rebate u/s 87A auto-considered where eligible (taxable income ≤ ₹7L for New, ≤ ₹5L for Old regime).</li>
              <li>Monthly TDS plan distributes remaining balance across available months with rounding to nearest ₹10.</li>
              <li>HR overrides and adjustments are logged. <a href="#">View Audit Trail</a></li>
            </ul>
          </div>
        </div>
    </div>
  )
}

export default TdsCalculation